import React from 'react';
import { Box, Text, Flex, Image } from 'rebass/styled-components';
import UserAvatarOne from '../../../assets/claim-profile/user-avatar-1.png';
import Vector2 from '../../../assets/lucide/vector2.svg';
import Comp from '../../../assets/companies-large/compa.svg';
import IndexVentures from '../../../assets/companies-large/indexVentures.svg';
import Solana from '../../../assets/companies-large/solana.svg';
import Invisible from '../../../assets/companies-large/invisible.svg';
import Techstars from '../../../assets/companies-large/techstars.svg';
import FlyFlat from '../../../assets/companies-large/flyFlat.svg';

export const ClaimProfileSidebar = () => (
  <Box
    sx={{
      background: 'radial-gradient(243.75% 127.19% at 51.98% 100%, #7E16FF 0%, #4900FF 75.94%, #00005A 100%)',
      flexDirection: 'column',
      alignItems: 'center',
      height: '100vh',
      width: '480px',
      minWidth: '480px',
      display: ['none', 'none', 'flex'],
      p: '80px 40px',
      justifyContent: 'space-between',
      position: 'fixed',
      right: 0,
      zIndex: 1000,
    }}
  >
    <Flex
      sx={{
        flexDirection: 'column',
        alignItems: 'center',
        gap: '80px',
      }}
    >
      <Text sx={{ fontSize: '28px', fontWeight: '700', color: 'neutral.0', textAlign: 'center' }}>
        Put your network to work with Getro
      </Text>

      <Flex sx={{ width: '400', justifyContent: 'space-between', gap: '16px' }}>
        <Box sx={{ position: 'relative', width: '64px', height: '64px' }}>
          <Box
            sx={{
              backgroundImage: `url(${UserAvatarOne})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              width: '64px',
              height: '64px',
              borderRadius: '64px',
            }}
          />
          <Box
            sx={{
              background: 'linear-gradient(219deg, #702DFF 15.72%, #F4F 73.31%)',
              opacity: 0.7,
              mixBlendMode: 'lighten',
              width: '64px',
              height: '64px',
              borderRadius: '64px',
              position: 'absolute',
              top: 0,
              left: 0,
            }}
          ></Box>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <Flex sx={{ position: 'relative', maxWidth: '346px' }}>
            <Box>
              <Image src={Vector2} sx={{ position: 'relative', top: '15px' }} />
            </Box>
            <Box
              sx={{
                borderRadius: '4px',
                bg: 'purple.400',
                p: '8px',
                width: '320px',
                position: 'relative',
              }}
            >
              <Text fontSize="16px" fontWeight="500" color="neutral.0">
                Thanks to Getro, we got warm intros to our sales targets. Even ones that Sales Navigator missed.
              </Text>
            </Box>
          </Flex>
          <Box ml="6px">
            <Text sx={{ color: 'neutral.0', fontWeight: 600, fontSize: '14px' }}>Justo Varela</Text>
            <Text sx={{ color: 'neutral.0', fontWeight: 400, fontSize: '14px' }}>Growth Specialist at FlyFlat</Text>
          </Box>
        </Box>
      </Flex>
    </Flex>

    <Flex sx={{ flexDirection: 'column', alignItems: 'center', gap: '24px' }}>
      <Text
        sx={{
          fontSize: '12px',
          fontWeight: 500,
          letterSpacing: '1px',
          textTransform: 'uppercase',
          color: 'neutral.0',
        }}
      >
        Trusted by top investors and companies
      </Text>
      <Flex sx={{ columnGap: '24px', rowGap: '8px', flexWrap: 'wrap' }}>
        <Image src={Comp} alt="Compa logo" />
        <Image src={Techstars} alt="Techstars logo" />
        <Image src={Invisible} alt="Invisible logo" />
        <Image src={IndexVentures} alt="Index Ventures logo" />
        <Image src={Solana} alt="Solana logo" />
        <Image src={FlyFlat} alt="FlyFlat logo" />
      </Flex>
    </Flex>
  </Box>
);
